/**
 * Generates a hash string from the input string
 */
export function hash(str: string): string {
    let hashValue = 0;
    let char = 0;

    if (str.length === 0) {
        return hashValue.toString();
    }

    for (let i = 0; i < str.length; i++) {
        char = str.charCodeAt(i);
        hashValue = (hashValue << 5) - hashValue + char;
        hashValue = hashValue & hashValue;
    }

    return hashValue.toString();
}
